module.exports = __webpack_public_path__ + "img/chart-flowers-2-2x.1103b2f1.png";